import AcceptPoliciesModal from './AcceptPoliciesModal';
import UpdateAlert from './UpdateAlert';
import UserPoliciesStateModal from './UserPoliciesStateModal';

export const components = {
  AcceptPoliciesModal,
  UpdateAlert,
  UserPoliciesStateModal,
};
